import type {
  GetListRequest,
  GetListResponseOfSkillResponse,
  SkillCreateRequest,
  SkillResponse,
  SkillUpdateRequest,
} from 'src/api/ProactApiClient';
import {skillApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

export const skillApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getSkillList: builder.query<GetListResponseOfSkillResponse, GetListRequest>({
      queryFn: clientQuery(request => skillApiClient.getList(request)),
      providesTags: ['Skills'],
    }),
    getSkill: builder.query<SkillResponse, number>({
      queryFn: clientQuery(id => skillApiClient.get(id)),
      providesTags: ['Skills'],
    }),
    createSkill: builder.mutation<SkillResponse, SkillCreateRequest>({
      queryFn: clientQuery(request => skillApiClient.create(request)),
      invalidatesTags: ['Skills'],
    }),
    updateSkill: builder.mutation<SkillResponse, SkillUpdateRequest>({
      queryFn: clientQuery(request => skillApiClient.update(request)),
      invalidatesTags: ['Skills'],
    }),
    deleteSkill: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => skillApiClient.delete(id)),
      invalidatesTags: ['Skills'],
    }),
  }),
});

export const {
  useGetSkillListQuery,
  useGetSkillQuery,
  useCreateSkillMutation,
  useUpdateSkillMutation,
  useDeleteSkillMutation,
} = skillApi;
